import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

/** T94 — 404 Không tìm thấy trang. */
export function NotFoundPage() {
  return (
    <div className="flex justify-center px-6 py-16">
      <Card className="w-full max-w-[540px] text-center">
        <CardContent className="p-8">
          <div className="text-[56px] font-bold leading-none text-muted-foreground">
            404
          </div>
          <h1 className="mt-2 text-2xl font-semibold text-foreground">
            Không tìm thấy trang
          </h1>
          <p className="mt-1 text-muted-foreground">
            Đường dẫn bạn vừa truy cập không tồn tại hoặc đã được di chuyển.
          </p>
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            <Button asChild>
              <Link to="/dashboard">Về Dashboard</Link>
            </Button>
            <Button
              type="button"
              variant="secondary"
              onClick={() => window.history.back()}
            >
              Quay lại
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
